import { Button, VStack, HStack } from '@chakra-ui/react';
import { MainTemplate } from '../../templates/MainTemplate';
import { useTheme } from '../../contexts/ThemeProvider';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { PromotionGrid } from '../../components/molecules/PromotionGrid';
import { Categories } from '../Deals/components/Categories';
import { Label } from '../../components/atoms/Label';

export function FavoritesPage() {
  const { colors } = useTheme();
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const navigate = useNavigate();

  return (
    <MainTemplate>
      <VStack align={'self-start'} width="90%" marginBottom={'100px'} paddingTop={'20px'} spacing={6}>
        <HStack>
          <Button variant={'link'} onClick={() => navigate(-1)} gap={2}>
            <FaArrowLeftLong color={colors.primaryColor} />
          </Button>
          <Label>Curtiu? Aproveite</Label>
        </HStack>

        <Categories selectedCategories={selectedCategories} setSelectedCategories={setSelectedCategories} />

        <PromotionGrid
          column
          fullWidth
          params={{
            favorite: true,
          }}
        />
      </VStack>
    </MainTemplate>
  );
}
